__turbopack_context__.v({
  "addressInputEndAdornment": "WalletSend-module__7MyZPG__addressInputEndAdornment",
  "altCurrency": "WalletSend-module__7MyZPG__altCurrency",
  "altCurrencyIcon": "WalletSend-module__7MyZPG__altCurrencyIcon",
  "altCurrencyLabel": "WalletSend-module__7MyZPG__altCurrencyLabel",
  "balanceTitle": "WalletSend-module__7MyZPG__balanceTitle",
  "cancelButton": "WalletSend-module__7MyZPG__cancelButton",
  "description": "WalletSend-module__7MyZPG__description",
  "error": "WalletSend-module__7MyZPG__error",
  "form": "WalletSend-module__7MyZPG__form",
  "header": "WalletSend-module__7MyZPG__header",
  "icon": "WalletSend-module__7MyZPG__icon",
  "input": "WalletSend-module__7MyZPG__input",
  "inputEndAdornment": "WalletSend-module__7MyZPG__inputEndAdornment",
  "loading": "WalletSend-module__7MyZPG__loading",
  "receive": "WalletSend-module__7MyZPG__receive",
  "root": "WalletSend-module__7MyZPG__root",
  "sendRcvIconContainer": "WalletSend-module__7MyZPG__sendRcvIconContainer",
});
